<template>
  <div class="main">
    <Header
      :show="true"
      :title="listQuery.typeName || '字典'"
      left="prepage"
      right="create"
      :click-left="handleClickLeft"
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh">
      <van-notice-bar
        wrapable
        :scrollable="false"
        left-icon="info-o"
        text="管理对应字典的数据信息"
      />
      <el-table
        ref="table"
        :data="table.data"
        row-key="id"
        @row-click="handleTableRowClick"
      >
        <el-table-column
          type="expand"
          width="30px"
        >
          <template slot-scope="{ row }">
            <div style="padding: 0 12px">
              <el-form
                label-position="left"
                label-width="100px"
              >
                <div class="table-expand">
                  <el-form-item label="数据标签">
                    {{ row.label }}
                  </el-form-item>
                  <el-form-item label="数据编码">
                    {{ row.code }}
                  </el-form-item>
                  <el-form-item label="数据值">
                    {{ row.value }}
                  </el-form-item>
                  <el-form-item label="备注">
                    {{
                      row.description
                    }}
                  </el-form-item>
                </div>
              </el-form>
              <div style="margin-top: 10px">
                <van-button
                  size="small"
                  style="margin-right: 10px"
                  type="info"
                  @click="handleClickUpdate(row)"
                >
                  编辑类型
                </van-button>
                <van-button
                  size="small"
                  style="margin-right: 10px"
                  type="danger"
                  @click="handleClickDelete(row)"
                >
                  删除字典
                </van-button>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="序号"
          type="index"
          align="center"
          width="60"
        />
        <el-table-column
          label="数据标签"
          prop="label"
          show-overflow-tooltip
          width="100"
        />
        <el-table-column
          label="数据编码"
          prop="code"
          show-overflow-tooltip
          width="100"
        />
        <el-table-column
          label="数据值"
          prop="value"
          show-overflow-tooltip
        />
      </el-table>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
import { Dialog } from "vant";
import { showPhoneAlarm } from "@/global/function.js";
import checkPermission from "@/utils/permission";
import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";
import { deleteData as deleteOne, getDicyType } from "@/api/dict.js";

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      listQuery: {
        type: "",
      },
      table: {
        listLoading: false,
        fullWidth: document.documentElement.clientWidth,
        key: 0,
        total: 0,
        data: [],
      },
      loading: false,
    };
  },
  created() {
    this.listQuery.type = this.$route.query.type;
    this.handleClickQuery();
  },
  methods: {
    checkPermission,
    handleClickLeft() {
      this.$router.go(-1);
    },
    handleClickRight() {
      this.$router.push({
        path: "/service/system/dictdata/create",
        query: this.listQuery,
      });
    },
    handleTableRowClick(row, column, event) {
      this.$refs.table.toggleRowExpansion(row);
    },
    handleClickQuery() {
      getDicyType(this.listQuery).then((response) => {
        const { data } = response;
        if (!data.data.length) return;
        else {
          const { dictDataList, id, name } = data.data[0];
          this.table.total = dictDataList.length;
          this.table.data = dictDataList;

          this.listQuery.typeId = id;
          this.listQuery.typeName = name;
        }
      });
    },
    handleClickUpdate(row) {
      this.$router.push({
        path: "/service/system/dictdata/update",
        query: { typeName: this.listQuery.typeName, ...row },
      });
    },
    handleClickDelete(row) {
      Dialog.confirm({
        title: "确认删除此字典数据？",
      })
        .then(() => {
          this.loading = true;
          const data = row.id;
          deleteOne(data)
            .then((response) => {
              const { data } = response;
              if (
                showPhoneAlarm(
                  true,
                  "toast",
                  null,
                  2000,
                  data.code,
                  "删除",
                  data.message
                )
              ) {
                this.loading = false;
                this.handleClickQuery();
              }
            })
            .catch(function (error) {});
        })
        .catch(() => {
          showPhoneAlarm(true, "toast", null, 2000, 200, "删除", "取消");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 100%;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
// 自定义样式
.main {
  height: 100vh;
  font-size: 2vw;
  background-color: #ffffff; //#F7F8FA;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
